import { useFetchFeatureFlags } from '@@/common/hooks/useFetchFeatureFlags';
import { useFeatureFlags } from '@@/common/services/useFeatureFlags';

import { featureFlag } from '../constants/featureFlags';

export function useOktaIssuer(
  opts: { originOnly: boolean } = { originOnly: false }
) {
  const { isLoadingFeatureFlags } = useFetchFeatureFlags();
  const { isFeatureEnabled } = useFeatureFlags();

  if (isLoadingFeatureFlags) {
    // It's not possible for this to be read in the app, since we wait until
    // we've loaded feature flags before we render the app within App.tsx.
    // This is just to appease TypeScript.
    return '';
  }

  function getIssuerUrl() {
    if (
      isFeatureEnabled(featureFlag.USE_NEW_TOY_OKTA_URL) &&
      process.env.REACT_APP_TENANT === 'toyota' &&
      process.env.REACT_APP_ENV === 'production'
    ) {
      // Temporarily gate this behind a feature flag. Once this has been
      // deployed successfully update process.env.REACT_APP_OKTA_ISSUER with
      // the string below, and remove the feature flag.
      // TODO sc-246363
      return 'https://signin.app.toyotaautoinsurance.com/oauth2/aus3yzjga2NAetsGc357';
    }
    return process.env.REACT_APP_OKTA_ISSUER;
  }

  const url = getIssuerUrl();

  return opts.originOnly ? new URL(url).origin : url;
}
